import styled from "@emotion/styled";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface CheckCircleOutlineIconProps {
	size: string | number;
}

export const ReplacementControls = styled.div(({ theme }) => ({
	margin: 0,
	display: "flex",
	justifyContent: "center",
	flexDirection: "column",
	height: "100%",
	width: "180px",
	marginLeft: "8px",
	div: {
		color: "var(--success-green)",
		fontSize: "var(--font-size-3)",
		textTransform: "unset",
		marginTop: ".25rem",
		fontFamily: "canada-type-gibson, sans-serif",
		fontWeight: "var(--font-weight-medium)",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: "6px",
		p: {
			margin: "2px 0 0 0"
		}
	},
	button: {
		width: "100%",
		padding: "4px 10px"
	},
	[theme.breakpoints.down("md")]: {
		marginTop: 4,
		marginBottom: 16
	}
}));

export const StyledCheckCircleOutlineIcon = styled(CheckCircleOutlineIcon)<CheckCircleOutlineIconProps>(({ size }) => ({
	width: size,
	height: size
}));

export const LineItemGridWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "column",
	gap: 8
}));

export const LineAddedMessage = styled.div(({ theme }) => ({
	"&&&&&": {
		...theme.project.typography.subtitle.subtitle2,
		color: theme.project.colors.semanticColors.success,
		letterSpacing: "0.15px",
		lineHeight: "143%"
	}
}));

export const GlobalInfo = styled.div(({ theme }) => ({
	div: {
		"&:first-of-type": {
			...theme.project.typography.heading.h6,
			color: theme.project.colors.fontColors.main,
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			gap: "16px"
		},
		"&:nth-child(2)": {
			...theme.project.typography.overline,
			color: theme.project.colors.fontColors.secondary,
			lineHeight: "200%",
			textTransform: "uppercase"
		}
	}
}));
